export default {
    name: 'cookieOps',
  ///////// SET COOKIES USING THE COOKIE NAME AND THE VALUE OF THE COOKIE
  setCookie(c_name,data) {
    $cookies.set(c_name,data);

        },

       ///// CHECK CCOKIE FIND AND BRING IT OUT
   checkCookies(c_name){
       try{
  if($cookies.isKey(c_name) == true){
    return $cookies.get(c_name)
  }else{
    return false
  }
       }catch(e){
return false
       }
  },
  
  
//////// sweet allert serivice
  alertDisplay(w,x,y) {
    // $swal function calls SweetAlert into the application with the specified configuration.
    this.$swal(w, x,y);
  },

  }